"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var styles_1 = require("@material-ui/core/styles");
var react_dom_confetti_1 = __importDefault(require("react-dom-confetti"));
var Button_1 = __importDefault(require("../Button"));
var StreakIcon_1 = __importDefault(require("../StreakIcon"));
var useStyles = styles_1.makeStyles(function () {
    return styles_1.createStyles({
        label: {
            fontWeight: 'bold',
        },
    });
});
var StreakCounterButton = function (_a) {
    var active = _a.active, value = _a.value, showConfetti = _a.showConfetti, other = __rest(_a, ["active", "value", "showConfetti"]);
    var classes = useStyles();
    return (react_1.default.createElement(Button_1.default, __assign({ variant: "outlined", startIcon: react_1.default.createElement(StreakIcon_1.default, { active: active }) }, other),
        react_1.default.createElement("span", { className: classes.label }, value),
        react_1.default.createElement(react_dom_confetti_1.default, { active: showConfetti, config: {
                angle: 270,
                spread: 360,
                startVelocity: 13,
                elementCount: 65,
                dragFriction: 0.11,
                duration: 1280,
                stagger: 0,
                width: '6px',
                height: '6px',
                // perspective: 1000,
                colors: ['#a864fd', '#29cdff', '#78ff44', '#ff718d', '#fdff6a'],
            } })));
};
exports.default = StreakCounterButton;
//# sourceMappingURL=StreakCounterButton.js.map